// client/src/services/contactService.js
import api from './api.js';

// Helper to get server URL dynamically (same logic as api.js)
function getServerUrl() {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (process.env.NODE_ENV === 'production') {
    return '/api';
  }
  // In development, use same hostname but port 3001
  const { protocol, hostname } = window.location;
  return `${protocol}//${hostname}:3001/api`;
}

export const contactService = {
  getContacts: (params = '') => api.get(`/contacts?${params}`),
  getContact: (id) => api.get(`/contacts/${id}`),
  create: (data) => api.post('/contacts', data),
  update: (id, data) => api.put(`/contacts/${id}`, data),
  remove: (id) => api.del(`/contacts/${id}`),
  getTypes: () => api.get('/contacts/types/all'),
  createType: (data) => api.post('/contacts/types', data),

  // CSV Import
  importCSV: async (file) => {
    const formData = new FormData();
    formData.append('csv', file);
    return api.upload('/contacts/import-csv', formData);
  },

  // Download CSV template (static file in public folder)
  downloadTemplate: () => {
    window.open('/contacts-template.csv', '_blank');
  },

  // ─── Google Contacts Import ─────────────────────────────

  // Start the Google OAuth flow by redirecting to the server
  // Must use full server URL since this is a browser redirect, not an AJAX call
  startGoogleImport: () => {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('You must be logged in to import contacts');
    }
    const serverUrl = getServerUrl();
    window.location.href = `${serverUrl}/auth/google/contacts?token=${encodeURIComponent(token)}`;
  },

  // Fetch the imported contacts after Google OAuth callback
  getGoogleImportResults: () => api.get('/auth/google/contacts/results'),

  // ─── Microsoft Contacts Import ──────────────────────────

  // Start the Microsoft OAuth flow (same pattern as Google)
  startMicrosoftImport: () => {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('You must be logged in to import contacts');
    }
    const serverUrl = getServerUrl();
    window.location.href = `${serverUrl}/auth/microsoft/contacts?token=${encodeURIComponent(token)}`;
  },

  // Fetch the imported contacts after Microsoft OAuth callback
  getMicrosoftImportResults: () => api.get('/auth/microsoft/contacts/results'),

  // ─── Bulk Import (save selected contacts from any provider) ─

  // Takes an array of contacts from Google/Microsoft and creates them
  // Returns { imported, skipped, duplicates }
  bulkImportContacts: async (contacts) => {
    return api.post('/contacts/bulk-import', { contacts });
  },
};

export default contactService;